import { BusinessTypes } from '../../../constants/Enums';

export const stationSelectionInputState = (campaign) => {
    const state = { stepCompleted: false, stepEdited: false };
    if (campaign.businessType === BusinessTypes.AIRTIMEBURST.name) {
        if (campaign?.burstStations?.length > 0) {
            state.stepEdited = true;
        }
    } else {
        if (campaign?.campaignStations?.length > 0) {
            state.stepEdited = true;
        }
    }
    // ToDo: add any further checks required

    return state;
};

export const getStations = (networks) => {
    const parseChildren = (n, s) => {
        if (n.children.length) {
            n.children.map((a, b) => parseChildren(a, s));
        } else {
            if (!s.find((s) => s.id == n.id)) s.push(n);
        }
    };
    const stationsData = [];
    networks?.forEach((network) => {
        parseChildren(network, stationsData);
    });

    return stationsData;
};

export const getStationCount = (networks) => {
    return getStations(networks).length;
};
